<template>
    <!--begin::Wrapper-->
    <div id="dnn_ctr464_ModuleContent" class="DNNModuleContent ModDNNHTMLC">
        <div id="dnn_ctr464_HtmlModule_lblContent" class="Normal">
            <div class="pageBg">
                <div class="pageBgInners mt-20" data-aos="fade-up">
                    <div class="container mt-20">
                        <div class="row mt-20 justify-content-center">
                            <div class="col-md-12  mt-20">
                                <div class="row mt-20">
                                    <div class="col-md-12 mt-20"></div>

                                    <div class="col-md-12">
                                        <div v-if="loading"
                                             class="row justify-content-center bg-white rounded shadow-sm p-10 p-lg-15  mx-auto">
                                            <div class="col-12" v-for="k in [1,2,3]">
                                                <div class="row">
                                                    <div class="col-12 text-center mb-10"></div>
                                                    <div class="col-md-4 mb-10 text-center">
                                                        <free-style-shimmer :is-loading='true' height='10px'
                                                                            width='200px'
                                                                            color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-md-4 mb-10 text-center">
                                                        <free-style-shimmer :is-loading='true' height='10px'
                                                                            width='200px'
                                                                            class="w-100"
                                                                            color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-md-4 mb-10 text-center">
                                                        <free-style-shimmer :is-loading='true' height='10px'
                                                                            width='200px'
                                                                            color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-12 text-center mb-10"></div>
                                                    <div class="col-md-6 mb-10 text-center">
                                                        <free-style-shimmer :is-loading='true' height='10px'
                                                                            width='200px'
                                                                            color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-md-6 mb-10 text-center">
                                                        <free-style-shimmer :is-loading='true' height='10px'
                                                                            width='200px'
                                                                            class="w-100"
                                                                            color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-12 text-center mb-10"></div>
                                                    <div class="col-md-6 mb-10 text-center">
                                                        <free-style-shimmer :is-loading='true' height='10px'
                                                                            width='200px'
                                                                            color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-md-6 mb-10 text-center">
                                                        <free-style-shimmer :is-loading='true' height='10px'
                                                                            width='200px'
                                                                            color='#bdbdbd'/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card" v-if="ProgramData">
                                            <div class="card-header">
                                                <div class="card-title fs-2 fw-bolder">
                                                    <slot v-if="i18n.locale.value == 'ar'">
                                                        {{ProgramData ? ProgramData.name.ar : ''}}
                                                    </slot>
                                                    <slot v-if="i18n.locale.value == 'en'">
                                                        {{ProgramData ? ProgramData.name.en : ''}}
                                                    </slot>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-8">
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div v-if="!ProgramData.isActive" class="bg-danger p-2 text-center text-white mt-5">
                                                                    {{$t('unavailable')}}
                                                                </div>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <vs-tabs>
                                                                    <vs-tab color="danger" defaultColor="dark"
                                                                            :label="$t('terms')">
                                                                        <div class="con-tab-ejemplo fs-5">
                                                                            <slot v-if="i18n.locale.value == 'ar'">
                                                                                <div v-html="ProgramData.termsAndConditions.ar"></div>
                                                                            </slot>
                                                                            <slot v-if="i18n.locale.value == 'en'">
                                                                                <div v-html="ProgramData.termsAndConditions.en"></div>
                                                                            </slot>
                                                                        </div>
                                                                    </vs-tab>
                                                                    <vs-tab color="danger" defaultColor="dark"
                                                                            :label="$t('description')">
                                                                        <div class="con-tab-ejemplo fs-5">
                                                                            <slot v-if="i18n.locale.value == 'ar'">
                                                                                {{ProgramData ?
                                                                                ProgramData.description.ar : ''}}
                                                                            </slot>
                                                                            <slot v-if="i18n.locale.value == 'en'">
                                                                                {{ProgramData ?
                                                                                ProgramData.description.en : ''}}
                                                                            </slot>
                                                                        </div>
                                                                    </vs-tab>
                                                                    <vs-tab color="danger" defaultColor="dark" v-if="ProgramData.fact_sheet"
                                                                            :label="$t('fact_sheets')">
                                                                        <div class="con-tab-ejemplo fs-5">
                                                                            <i class="uil uil-draggabledots"></i>
                                                                            {{ProgramData.fact_sheet }}
                                                                        </div>
                                                                    </vs-tab>
                                                                    <vs-tab color="danger" defaultColor="dark"  v-if="ProgramData.faqs_link"
                                                                            :label="$t('faqs')">
                                                                        <div class="con-tab-ejemplo fs-5">
                                                                            <a class="text-danger" :href="ProgramData.faqs_link">
                                                                                <i class="uil uil-draggabledots"></i>
                                                                                {{$t('press_show_details')}}
                                                                            </a>
                                                                        </div>
                                                                    </vs-tab>
                                                                </vs-tabs>
                                                                <hr>
                                                                <div class='text-center d-flex justify-content-between fs-5' v-if="ProgramData">
                                                                    <template v-if="userCanApply">
                                                                      <label v-if="ProgramData.isActive"
                                                                             class="form-check form-switch form-check-custom form-check-solid">
                                                                        <input v-model="acceptTerms"
                                                                               class="form-check-input"
                                                                               name="acceptTerms"
                                                                               type="checkbox"
                                                                               value="1"/>
                                                                        <span class="form-check-label fw-bold"
                                                                              :class="acceptTerms ? 'text-dark' : 'text-gray-400'"> &nbsp; {{$t('acceptTerms')}} </span>
                                                                      </label>
                                                                      <button v-if="ProgramData.isActive" type='button' class='btn btn-danger'
                                                                              :disabled="!acceptTerms || !ProgramData.isActive"
                                                                              @click="goToApplyPrograms(ProgramData)">
                                                                        <i class="uil uil-file"></i>
                                                                        {{ $t('apply') }}
                                                                      </button>
                                                                    </template>
                                                                    <template v-else>
                                                                      <div class="alert alert-danger bg-danger w-100 text-white">
                                                                        {{ $t('sorry_cnot_apply') }}
                                                                      </div>
                                                                    </template>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="text-center">
                                                            <img v-if="ProgramData.image" :src="$helpers.getImagePath(store.getters['moduleCommon/getConfigImagePath']+ProgramData.image)" class="w-100" alt="">
                                                            <img v-if="!ProgramData.image" :src="require('@/assets/images/no_image.png')" class="w-100" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cloudsTop"></div>
            </div>
        </div>
    </div>
    <!--end::Wrapper-->
</template>

<script lang="ts">
    import {defineComponent, ref, reactive, toRefs, inject, computed, onMounted} from "vue";
    import {ErrorMessage, Field, Form} from "vee-validate";
    import {useStore} from "vuex";
    import {useRouter, useRoute} from "vue-router";
    import {Tab} from "bootstrap";
    import {useI18n} from 'vue-i18n';
    import AOS from "aos";
    import * as _ from "lodash";

    import FormInput from '@/views/programs/components/FormInput.vue'
    import FormFileInput from '@/views/programs/components/FormFileInput.vue'
    import FormDateInput from '@/views/programs/components/FormDateInput.vue'
    import FormCheckboxInput from '@/views/programs/components/FormCheckboxInput.vue'
    import RecursiveSelect from '@/views/programs/components/RecursiveSelect.vue'
    import FormBuilder from '@/views/programs/components/FormBuilder.vue'

    export default defineComponent({
        name: "apply",
        components: {
            Tab,

            Field,
            Form,
            ErrorMessage,

            FormBuilder,
            RecursiveSelect,
            FormCheckboxInput,
            FormDateInput,
            FormFileInput,
            FormInput,
        },
        setup(props, context) {
            const helpers: any = inject("helpers");
            const store = useStore();
            const router = useRouter();
            const route = useRoute();
            const i18n = useI18n();
            const {t} = useI18n();

            const user = computed(() => {
                return store.getters['moduleAuth/getAuthUser'];
            });

            let emptyArray: any = [];
            const state = reactive({
                loading: false,
                started: false,
                acceptTerms: false,
                userCanApply: false,

                ProgramData: null,
                steps: emptyArray,
            });

            onMounted(() => {
                AOS.init();
                getProgram();
            });

            const getProgram = () => {
                state.loading = true;
                let id: any = route?.params?.id;
                store.dispatch("modulePrograms/findProgramDetails", {id: id})
                    .then(({data}) => {
                        state.loading = false;
                        let response = data.data;
                        state.ProgramData = data.data;
                        state.userCanApply = data.data.userCanApply || false;
                        state.steps = response.dynamicFormsJsonWithOrder
                    })
                    .catch((response) => {
                        state.loading = false;
                        helpers.handleResponse(response, t, router, store, {});
                    });
            };

            const goToApplyPrograms = (item) => {
                router.push({name: 'apply_program_page', params: {id: item._id}})
            };

            return {
                ...toRefs(state),
                goToApplyPrograms,
                i18n,
                store,
                user,
            };
        },
    });
</script>
<style>
    .vs-tabs--li {
        font-size: 15px;
        font-weight: bold;
    }
</style>
